<template>
    <div id="app">
        <div id="chatContent" v-show="showWidget" v-bind:class="(mode !== 'widget' ? 'chat-content chat-mobile-app' : 'chat-content')">
            <div v-if="(company == 101 && (this.UrlAddress !== 'digital.tel.inf.br' || this.UrlAddress !== '162.214.55.131:8080'))" id="chat-iframe" v-bind:class="(mode !== 'widget' ? 'chat-content chat-mobile-app' : 'iframe-pms')">
                <div id="chat-window" v-bind:class="(mode !== 'widget' ? 'chat-window chat-mobile-app' : 'chat-window')">
                    <router-view
                        :key="chatCount"
                        @encerraSessao="encerraSessao"
                    />
                </div>
            </div>
            <div v-else id="chat-iframe" v-bind:class="(mode !== 'widget' ? 'chat-content chat-mobile-app' : 'chat-iframe')">
                <div id="chat-window" v-bind:class="(mode !== 'widget' ? 'chat-window chat-mobile-app' : 'chat-window')">
                    <router-view
                        :key="chatCount"
                        @encerraSessao="encerraSessao"
                    />
                </div>
            </div>
            <div v-if="$route.path === '/bot'">
                <button :style="styleObject" class="btn-chat-ballon" id="btn-chat-ballon" @click="handleChatWindow">
                    <img src="@/assets/pms.png" id="icon-chat" alt="" style="display: none">
                    <img src="@/assets/close-outline.svg" id="icon-close" alt="" style="display: flex">
                </button>
                <!-- <button :style="styleObject" class="btn-chat-ballon" id="btn-chat-ballon" @click="handleChatWindow" style="overflow: hidden">
                    <img src="@/assets/css/robo.png" class="img-iara" id="icon-chat" alt="" style="display: none;">
                    <img src="@/assets/close-outline.svg" id="icon-close" alt="" style="display: flex">
                </button> -->
            </div>
            <div v-if="(company == 101 && (this.UrlAddress !== 'digital.tel.inf.br' || this.UrlAddress !== '162.214.55.131:8080'))">
                <button :style="styleObject" class="btn-chat-ballon" id="btn-chat-ballon" @click="handleChatWindow">
                    <img src="@/assets/pms.png" id="icon-chat" alt="" style="display: none">
                    <img src="@/assets/close-outline.svg" id="icon-close" alt="" style="display: flex">
                </button>
            </div>
            <div v-else-if="(company == 16 && (this.UrlAddress == 'digital.tel.inf.br' || this.UrlAddress == '162.214.55.131:8080'))">
                <button :style="styleObject" class="btn-chat-ballon" id="btn-chat-ballon" @click="handleChatWindow">
                    <img src="@/assets/css/minerva.jpg" class="img-iara" id="icon-chat" alt="" style="display: none">
                    <img src="@/assets/close-outline.svg" id="icon-close" alt="" style="display: flex">
                </button>
            </div>
            <div v-else>
                <button :style="styleObject" class="btn-chat-ballon" id="btn-chat-ballon" @click="handleChatWindow">
                    <img src="@/assets/widget.png" id="icon-chat" alt="" style="display: none">
                    <img src="@/assets/close-outline.svg" id="icon-close" alt="" style="display: flex">
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import io from "socket.io-client";

export default {
    data() {
        return {
            io: io(process.env.VUE_APP_SOCKET_ENDPOINT),
            socketEndpoint: process.env.VUE_APP_SOCKET_ENDPOINT,
            recoveredChat: false,
            recoveredFilaChatId: false,
            primary_color: "",
            secondary_color: "",
            cor_botao_chat: "",
            btnBeginLabel: '',
            company: '',
            openChat: '',
            widgetParapeters: '',
            showWidget: false,
            widget: this.$route.query.widget,
            chatCount: 1,
            newChat: true,
            openingHoursChat: {},
            mode: this.$route.query.mode || 'widget',
            contact: {},
            id_contato: null,
            tela_personalizada: this.$route.query.tela || false,
            cookie: this.$route.query.cookie || this.getCookie('cosmos_widget_token'),
            uuid: this.$route.query.uuid ? this.$route.query.uuid : "",
            UrlAddress:""
        };
    },
    computed:{

        styleObject: function() {
            return {
                backgroundColor: this.cor_botao_chat,
            }
        }
    },
    methods: {
        encerraSessao: function () {
            this.cookie = '';
            this.recoveredFilaChatId = '';
            this.recoveredChat = false;
            if(this.mode == 'mobile')
                this.setCookie('cosmos_widget_token', '', 7);
            else
                if(this.company !== 16)
                    window.parent.postMessage({type: 'token', token: ''}, '*');
            this.newChat = false;
            this.chatCount++;
        },
        setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        resizeIframe: function (open){
            if (this.$route.query.company == 101 || this.company == 101) {

                window.parent.postMessage({type: 'resize', open, pms:true}, '*');
            }else{

                window.parent.postMessage({type: 'resize', open, pms:false}, '*');
            }
        },

        handleChatWindow: function() {
            let windowChat = document.getElementById('chat-iframe');
            let IconChat = document.getElementById('icon-chat');
            let IconClose = document.getElementById('icon-close');
            let btnChatBallon = document.getElementById('btn-chat-ballon');
            let chatContent = document.getElementById('chatContent');

            if(this.openChat === false){
                this.openChat = true;
                this.resizeIframe(true);
                if(this.company == 16){
                    chatContent.style.right = '83px'
                }
                btnChatBallon.style.display = "none";
                windowChat.style.display = "block";
                IconChat.style.display = "none";
                IconClose.style.display = "flex";

            }
            else{
                this.openChat = false;
                this.resizeIframe(false);
                btnChatBallon.style.display = "flex";
                windowChat.style.display = "none";
                IconChat.style.display = "flex";
                IconClose.style.display = "none";

            }
        },

        GetUrl(){
           let urlAddress =  window.location.href.split('/');
            this.UrlAddress = urlAddress[2];
            this.company = this.$route.query.company;

        }
    },
    mounted() {
        this.GetUrl();

        if(this.mode === 'mobile') {
            this.openChat = true;
            this.showWidget = true;
        }
        this.contact = {
            name: this.$route.query.name,
            phone: this.$route.query.phone ? this.$route.query.phone : '',
            email: this.$route.query.email ,
            cpf: this.$route.query.cpf ? this.$route.query.cpf : ''
        }

        this.io.emit("getChat", {
            id: this.$route.query.id,
            company: this.$route.query.company,
            widget: this.$route.query.widget,
            hash: this.$route.query.id,
            uuid: this.$route.query.uuid,
            cookie: this.cookie,
            contact: this.contact,
        });
        this.io.on("widgetFail", (data) => {
            console.error(data);
        });
        this.io.on("chatReceived",(data) => {
            this.handleChatWindow();
            this.recoveredChat = data.recoveredChat;
            this.company = data.company;
            this.widgetParapeters = data.widgetParapeters;
            this.openingHoursChat = data.openingHoursChat;
            this.id_contato = data.id_contato;

            if(this.recoveredChat){
                this.recoveredFilaChatId = data.recoveredFilaChatId;
                this.newChat = false;
            }

            for(let i=0; i<data.parameters.length;i++){
                if(data.parameters[i].parametro === "cor_primaria_chat")
                    this.primary_color = data.parameters[i].valor;
                if(data.parameters[i].parametro === "cor_secundaria_chat")
                    this.secondary_color = data.parameters[i].valor;
                if(data.parameters[i].parametro === "cor_botao_chat")
                    this.cor_botao_chat = data.parameters[i].valor;
            }
            this.showWidget = true;
            let path = this.tela_personalizada ? '/' + this.tela_personalizada : 'chat';
            this.$router.push({
                path: path,
            });
        });

        this.openChat = (this.$route.query.open === "0" || this.$route.query.open === 'false');
        let windowChat = document.getElementById('chat-iframe');
        windowChat.style.display = "block";
    }
}
</script>
